// @ts-nocheck
import { createSelector } from 'reselect';

export const getResourcesStore = store => store.resources;

export const getBaseCurrencyCatalog = createSelector(
  [getResourcesStore],
  moduleStore => moduleStore.baseCurrencyCatalog
);

export const getUserRoles = createSelector([getResourcesStore], moduleStore => moduleStore.userRoles);

export const getUserPartners = createSelector([getResourcesStore], moduleStore => moduleStore.userPartners);

export const getUserTypes = createSelector([getResourcesStore], moduleStore => moduleStore.userTypes);

export const getBusinessUnits = createSelector([getResourcesStore], moduleStore => moduleStore.businessUnits);

export const getBusinessInsightsSiteViews = createSelector(
  [getResourcesStore],
  moduleStore => moduleStore.businessInsightsSiteViews
);
